/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UpdatePasswordRouteImport } from './routes/update-password'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCampaignsRouteImport } from './routes/_authenticated/campaigns'
import { Route as AuthenticatedCampaignsNewRouteImport } from './routes/_authenticated/campaigns.new'

const UpdatePasswordRoute = UpdatePasswordRouteImport.update({
  id: '/update-password',
  path: '/update-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCampaignsRoute = AuthenticatedCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCampaignsNewRoute =
  AuthenticatedCampaignsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedCampaignsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/update-password': typeof UpdatePasswordRoute
  '/campaigns': typeof AuthenticatedCampaignsRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/campaigns/new': typeof AuthenticatedCampaignsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/update-password': typeof UpdatePasswordRoute
  '/campaigns': typeof AuthenticatedCampaignsRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/campaigns/new': typeof AuthenticatedCampaignsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/update-password': typeof UpdatePasswordRoute
  '/_authenticated/campaigns': typeof AuthenticatedCampaignsRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/campaigns/new': typeof AuthenticatedCampaignsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/update-password'
    | '/campaigns'
    | '/dashboard'
    | '/onboarding'
    | '/settings'
    | '/campaigns/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/update-password'
    | '/campaigns'
    | '/dashboard'
    | '/onboarding'
    | '/settings'
    | '/campaigns/new'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth'
    | '/update-password'
    | '/_authenticated/campaigns'
    | '/_authenticated/dashboard'
    | '/_authenticated/onboarding'
    | '/_authenticated/settings'
    | '/_authenticated/campaigns/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
  UpdatePasswordRoute: typeof UpdatePasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/update-password': {
      id: '/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof UpdatePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/campaigns': {
      id: '/_authenticated/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AuthenticatedCampaignsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/campaigns/new': {
      id: '/_authenticated/campaigns/new'
      path: '/new'
      fullPath: '/campaigns/new'
      preLoaderRoute: typeof AuthenticatedCampaignsNewRouteImport
      parentRoute: typeof AuthenticatedCampaignsRoute
    }
  }
}

interface AuthenticatedCampaignsRouteChildren {
  AuthenticatedCampaignsNewRoute: typeof AuthenticatedCampaignsNewRoute
}

const AuthenticatedCampaignsRouteChildren: AuthenticatedCampaignsRouteChildren =
  {
    AuthenticatedCampaignsNewRoute: AuthenticatedCampaignsNewRoute,
  }

const AuthenticatedCampaignsRouteWithChildren =
  AuthenticatedCampaignsRoute._addFileChildren(
    AuthenticatedCampaignsRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedCampaignsRoute: typeof AuthenticatedCampaignsRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedCampaignsRoute: AuthenticatedCampaignsRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthRoute: AuthRoute,
  UpdatePasswordRoute: UpdatePasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
